export const environment = {
  production: false,
  apiUrl: 'https://api-new-acc.autotaxatiepartners.nl',
  application: 'avp-dashboard',
  password: 'gaDcSCKq64mxLCp522TvzClhkvOEMDlCV6N39qUDy',
  // First item will be the default, one entry will hide the field.
  level: ['customer']
};